import React, { useCallback } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { FcGoogle } from 'react-icons/fc';
import { userLogger } from '../utils/userLogger';

function GoogleSignInButton({ setUser }) {
  const login = useGoogleLogin({
    onSuccess: useCallback(async (tokenResponse) => {
      try {
        const res = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        });
        if (!res.ok) {
          const errorBody = await res.text();
          console.error('Google API error response:', errorBody);
          throw new Error(`Google API responded with status ${res.status}`);
        }
        const profile = await res.json();
        
        // Log successful sign-in
        console.log("🔐 USER_LOGIN", {
          timestamp: new Date().toISOString(),
          email: profile.email,
          name: profile.name,
          domain: profile.email.split('@')[1],
          loginMethod: 'Google OAuth (Button)',
          sessionId: Date.now().toString(36) + Math.random().toString(36).substr(2)
        });
        
        // Log to frontend logger
        userLogger.logSignIn({
          email: profile.email,
          name: profile.name,
          picture: profile.picture
        });
        
        setUser({ name: profile.name, email: profile.email, picture: profile.picture });
      } catch (err) {
        console.error('Google login failed:', err);
      }
    }, [setUser]),
    onError: (error) => {
      console.error('Google Login Hook Error:', error);
    },
  });

  const buttonStyles = {
    background: '#fff', // White background
    border: '1px solid #dadce0', // Google-like border
    borderRadius: '50%', // Circular shape
    width: '40px', // Fixed width
    height: '40px', // Fixed height
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    padding: '0', // Remove padding if icon is centered
    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.25)', // Subtle shadow
    transition: 'box-shadow .08s ease-in-out,background-color .08s ease-in-out',
  };

  const iconStyles = {
    fontSize: '20px', // Adjust icon size as needed
  };

  return (
    <button 
      onClick={() => login()} 
      style={buttonStyles} 
      aria-label="Sign in with Google"
      onMouseOver={(e) => e.currentTarget.style.boxShadow = '0 0 6px 0 rgba(0,0,0,0.3)'} // Slightly enhance shadow on hover
      onMouseOut={(e) => e.currentTarget.style.boxShadow = '0 2px 4px 0 rgba(0,0,0,0.25)'}
      onFocus={(e) => e.currentTarget.style.boxShadow = '0 0 6px 0 rgba(0,0,0,0.3)'} // For accessibility
      onBlur={(e) => e.currentTarget.style.boxShadow = '0 2px 4px 0 rgba(0,0,0,0.25)'}
    >
      <FcGoogle style={iconStyles} />
    </button>
  );
}

export default GoogleSignInButton;
